import React, { useEffect } from 'react';
import { clientInfo } from '@meitu/pc-bridge';
import { getFramework, useIdentity } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { IExportPlugin, PluginType } from '@/version-types';
import type { ClipboardPlugin } from '../../controller';

const ClipboardHotkeyView: React.FC = React.memo(() => {
    const identity = useIdentity();
    const framework = getFramework(identity);
    const { $t } = getLocaleStore();

    useEffect(() => {
        const handleCopy = (e: ClipboardEvent | null) => {
            e?.preventDefault();
            e?.clipboardData?.setData('text/plain', clientInfo.isClient ? '\r' : '');
            framework.service.registration.getInstance<ClipboardPlugin>('ClipboardPlugin').copy(e);
        };

        const handleCut = (e: ClipboardEvent | null) => {
            e?.preventDefault();
            e?.clipboardData?.setData('text/plain', clientInfo.isClient ? '\r' : '');
            framework.service.registration.getInstance<ClipboardPlugin>('ClipboardPlugin').cut(e);
        };

        const handlePaste = (e: ClipboardEvent | null) => {
            framework.service.registration.getInstance<ClipboardPlugin>('ClipboardPlugin').paste(e);
        };

        const handleFixedPaste = () => {
            const e = new ClipboardEvent('paste');
            document.dispatchEvent(e);
        };

        const handlers = [
            framework.service.hotkey.onPaste(handlePaste),
            framework.service.hotkey.onCopy(handleCopy),
            framework.service.hotkey.onCut(handleCut),
        ];

        framework.service.hotkey.register({
            name: $t((v) => v.Text_PasteFixed),
            win: 'Shift Ctrl V',
            mac: '⇧ ⌘ V',
            key: 'fixedPaste',
            processors: [
                {
                    press: ['Ctrl+Shift+V', 'Command+Shift+V'],
                    fn: handleFixedPaste,
                },
            ],
        });

        return () => {
            handlers.forEach((handler) => framework.service.events.off(handler));
        };
    }, []);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'clipboard-hotkey',
    render() {
        return <ClipboardHotkeyView />;
    },
};

export default exportPlugin;
